import { render, staticRenderFns } from "./MagicLinkPost.vue?vue&type=template&id=256f7d9d&scoped=true&"
import script from "./MagicLinkPost.vue?vue&type=script&lang=js&"
export * from "./MagicLinkPost.vue?vue&type=script&lang=js&"
import style0 from "./MagicLinkPost.vue?vue&type=style&index=0&id=256f7d9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256f7d9d",
  null
  
)

export default component.exports